
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M23.94 15.486c7.967-.117 17.5 12.5 17.5 12.5s-9.533 12.616-17.5 12.5c-7.81-.115-17-12.5-17-12.5.04-.054 9.208-12.385 17-12.5m.5 8a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M24.168 30.285a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M24.168 13.485c-10.69 0-16.8 12-16.8 12s6.11 12 16.8 12 16.8-12 16.8-12-6.109-12-16.8-12"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.001","d":"m11.923 9.823 2.62 2.883M23.979 6.94v3.407M36.033 9.823l-2.62 2.883"}})])
          )
        }
      }
    